import { createSlice } from "@reduxjs/toolkit";

import { postInsuranceLogin } from "../../reducer/insuranceLogin/insuranceLoginReducer";

//default value
const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const insuranceLoginSlice = createSlice({
  name: "insuranceLogin",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // Get Operation
      .addCase(postInsuranceLogin.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(postInsuranceLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(postInsuranceLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default insuranceLoginSlice.reducer;
